module.exports = __webpack_public_path__ + "static/img/ai_event_calendar.bf8dd1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ai_event_calendar.png
// module id = V/v3
// module chunks = 1